import moment from 'moment-timezone'

class DateFormatter {
  private moment: any
  private formatString: string
  private timezone: string
  private defaultTimezone: string

  constructor() {
    this.moment = moment
    this.formatString = ''
    this.timezone = moment.tz.guess()
    this.defaultTimezone = this.moment.tz.setDefault(DateFormatter.MAIN_TIMEZONE)
  }

  public setTimezone(zone: string) {
    this.timezone = zone
    return this
  }
  public setDefaultTimezone(zone: string) {
    this.defaultTimezone = this.moment.tz.setDefault(zone)
    return this
  }
  public resetDefaultTimezone() {
    this.defaultTimezone = this.moment.tz.setDefault()
    return this
  }
  public setFormat(formatString: string = '') {
    this.formatString = formatString
    return this
  }

  public setServerTimezone() {
    this.resetDefaultTimezone().setTimezone(DateFormatter.MAIN_TIMEZONE)
    return this
  }
  public setLocalTimezone() {
    this.setDefaultTimezone(DateFormatter.MAIN_TIMEZONE).setTimezone(moment.tz.guess())
    return this
  }

  public static get MAIN_TIMEZONE() {
    return 'America/Los_Angeles'
  }

  public get(date: string|null = ''): string {
    if (date === null || !date.length) {
      return this.moment().tz(this.timezone).format(this.formatString)
    }
    return this.moment(date).tz(this.timezone).format(this.formatString)
  }
  public calendar(date: string|null = ''): string {
    if (date === null || !date.length) {
      return this.moment().tz(this.timezone).calendar()
    }
    return this.moment(date).tz(this.timezone).calendar()
  }
}

export default DateFormatter
